module.exports = __webpack_public_path__ + "images/logos-fleury.jpg?fd7d2a2d1fa9a0bfd9a4d87bda2a15f7";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/logos-fleury.jpg
// module id = 986
// module chunks = 0